/*
  created by jl - 2018/03/01
 */

var geo_location_cookie_name = '9k8KDFG23jIT5BNmwd83jflp28fj';
var geo_country = getCookie(geo_location_cookie_name);
var location_cookie_name = 'L923DF8dff830dfj2ft3f82mvhao4';
var current_location = getCookie(location_cookie_name);
var current_state = 'dom'; //TODO: use the "state" variable to decide if the UI needs to be updated or not.

var dom_int_component_open_button = $('.toggle_label, .toggle_icon');
var dom_int_toggle_component_container = $('.dom-int-toggle-component');
var clicked_dom_int_toggle;

$(document).ready(function(){
	var do_check_location = ($('#dom_int_toggle_show_input').val() == 'true');
	var is_international_directory_page = checkUrlForInternational();

	if(do_check_location) {
		if(!geo_country && !current_location) {
			if(is_international_directory_page) {
				updateDomIntContentUI('int');
				updateOrSetDomIntCookie('int');
                setToolTipValue('int');
			} else {
				//GeoLocation not set, so set it
				setTimeout(function(){ 
					setGeoLocation(geo_location_cookie_name, 90);
				}, 2000);
			}
	    }
	    else {
	    	if(current_location && current_location.indexOf('international') > -1) {
	    		updateDomIntContentUI('int');
                setToolTipValue('int');
	    	} else {
	    		updateDomIntContentUI('dom');
                setToolTipValue('dom');
	    	}
	    }
	}
	else {
		if(is_international_directory_page) {
			updateDomIntContentUI('int');
			updateOrSetDomIntCookie('int');
		} else {
			updateDomIntContentUI('dom');
		}
	}

	dom_int_component_open_button.on("click", function () { 
		clicked_dom_int_toggle = $(this).closest('.dom-int-toggle-component');
		openToggleComponentModal();
		
	    return false;
	});

	//Help with tab indexes
	//TODO(JD): Restructure the HTML and CSS to allow these to tab properly
	$(document).on('keyup', '.locationswitch_yellow_button',function(e){
	    if(e.which==13 || e.which==32) {
	    	$(this).closest('.dom_int_toggle').click();
	    }
	});
}); //End document.ready function

//Check the current location pathname to see if it is under the international directory, if it is, return true
function checkUrlForInternational() {
	var current_location_pathname = window.location.pathname;
	var international_pathname = "/international";
	var international_pathname_content_root = "/content/flinders/en/international"; //If, for some reason, someone uses the long-form url.
	
	if (current_location_pathname && (current_location_pathname.indexOf(international_pathname) == 0 || current_location_pathname.indexOf(international_pathname_content_root) == 0)) {
		return true;
	}
	return false;
}

$('.change_to_domestic').on('click', function() {
	updateDomIntContentUI('dom');
	updateOrSetDomIntCookie('dom');
});
$('.change_to_international').on('click', function() {
	updateDomIntContentUI('int');
	updateOrSetDomIntCookie('int');
});


$('body').on('click', '.domesticSwitch', function(e) {
	updateDomIntContentUI('dom');
	updateOrSetDomIntCookie('dom');
	updateSubMenusOrRedirect('dom');
	hideTooltip();
    closeToolTip();
});

$('body').on('click', '.internationalSwitch', function() {
	updateDomIntContentUI('int');
	updateOrSetDomIntCookie('int');
	updateSubMenusOrRedirect('int');
	hideTooltip();
    closeToolTip();
});

$('#intlNavMobile').on('click', function() {
	updateDomIntContentUI('int');
	updateOrSetDomIntCookie('int');
	updateSubMenusOrRedirect('int');
    $('.header_burger').click();
});
$('#domNavMobile').on('click', function() {
	updateDomIntContentUI('dom');
	updateOrSetDomIntCookie('dom');
	updateSubMenusOrRedirect('dom');
    $('.header_burger').click();
});

function updateOrSetDomIntCookie(action) {
	var result = false;
	if(action === 'int') {
		result = setCookie(location_cookie_name, 'international', 90, 'overwrite');
	}
	else {
		result = setCookie(location_cookie_name, 'domestic', 90, 'overwrite');
	}
	return result;
}

//Accepting an "action" as a string (either 'dom' or 'int') will update all UI elements relating to the toggles in the header menu
function updateDomIntHeaderMenuToggleUI(action) {
	//TODO this still requires cleanup!

	if(action === 'dom') {
		$('.domesticSwitch').addClass("active");
        $('.internationalSwitch').removeClass("active");
        $('.domIntIcons svg:first-child').show();
        $('.domIntIcons svg:nth-child(2)').hide();
		//desktop
        $("#dom_int_toggle_icon_domestic").show();
        $("#dom_int_toggle_icon_international").hide();
        //mobile
        $('#domStudent').css("background-color", "#ffd300");
        $('#intlStudent').attr("style", "");
        $('#intlNavMobile').removeClass("active");
        $('#domNavMobile').addClass("active");
    } else if (action === 'int') {
    	$('.internationalSwitch').addClass("active");
        $('.domesticSwitch').removeClass("active");
        $('.domIntIcons svg:nth-child(2)').show();
        $('.domIntIcons svg:first-child').hide();
    	//desktop
        $("#dom_int_toggle_icon_domestic").hide();
        $("#dom_int_toggle_icon_international").show();
        //mobile - Work in progress
        $('#intlStudent').css("background-color", "#ffd300");
        $('#domStudent').attr("style", "");
        $('#intlNavMobile').addClass("active");
        $('#domNavMobile').removeClass("active");
    } else {
    	console.log('something went wrong :(');
    }
            
	return false;
}


//MAIN DOMESTIC/INTERNATIONAL CONTENT AND UI UPDATER (***NOT USED FOR UPDATING COOKIES!***)
//Accepting an "action" as a string (either 'dom' or 'int') - updates the display of content relevant to domestic or international students
//Will control the update of...
//- All dom/int content within the page (i.e. things labelled with .domestic_content and/or .international_content)
//- The Fast Facts UI
//- The Header Menu Dom/Int toggle UI
//- The Mobile Menu Dom/Int toggle UI
function updateDomIntContentUI(action) {
	current_state = action;
	var all_domestic_content = $('.domestic_content');
	var all_international_content = $('.international_content');
	//TODO - JD: Maybe move selector for is_course_page into FF UI update function
	var is_course_page = $('.course_pages').length > 0;
	var is_authoring = $('.aem_author_mode').length > 0;
	
	var has_dom_int_toggle_component = dom_int_toggle_component_container.length > 0;
	
	var all_hideable_course_page_content = $('.course_page_content_section:not(.never_hide)');
	var course_is_domestic_available = $('.course_pages').hasClass('is_domestic');
	var course_is_international_available = $('.course_pages').hasClass('is_international');
	var hide_invalid_information = (!course_is_domestic_available && action === 'dom') || (!course_is_international_available && action === 'int')

	if(is_authoring) {
		document.body.classList.add("is_domestic_content");
		document.body.classList.add("is_international_content");
		//show all dom and int content when authoring...for better or worse.
		all_domestic_content.show();
		all_international_content.show();
		//And just show default domestic header menu stuff when authoring
		updateDomIntHeaderMenuToggleUI('dom');
		updateToggleComponentUI('dom');
		all_hideable_course_page_content.show();
	} 
	else {
		//Not authoring
		if(is_course_page) {
			updateFastFactsUI(action);
			if(hide_invalid_information) {
				all_hideable_course_page_content.hide();
			} else {
				all_hideable_course_page_content.show();
			}
		}
		updateDomIntHeaderMenuToggleUI(action);
		
		if(has_dom_int_toggle_component) {
			updateToggleComponentUI(action);
		}
		if(action === 'dom') {      
			all_international_content.hide();
			all_domestic_content.show();

			document.body.classList.add("is_domestic_content");
			document.body.classList.remove("is_international_content");
	    } else if (action === 'int') {            	
			all_domestic_content.hide();
			all_international_content.show();

			document.body.classList.remove("is_domestic_content");
			document.body.classList.add("is_international_content");
	    } else {
	    	console.log('something went wrong :(');
	    }
	}     
	return false;
}

//Relating to study areas domestic/international menus and dom/int menus on  course pages
//UI updates will check the response of this function before proceeding
function updateSubMenusOrRedirect(action) {
	//Will handle redirects based on location and also dom/int content menu changes
	var is_course_page = $('.course_pages').length > 0;

	if(is_course_page) {
		//It is a course page, so do the stuff for that!
	} 
	else {
		//Only check if it is not a course page
		var location_to_change_to = getRedirectPartnerUrl(action);
		if(location_to_change_to) {
			//Change the window location
			window.location = location_to_change_to;
		}
	}

	return false;
}

//returns the location to move to if it exists
function getRedirectPartnerUrl(action) {
	var dom_redirect_input = $('#dom_redirect_url');
	var int_redirect_input = $('#int_redirect_url');

	if(action === 'dom' && dom_redirect_input.length) {
		return dom_redirect_input.val();
	}
	if(action === 'int' && int_redirect_input.length) {
		return int_redirect_input.val();
	}
	
	return false;
}


//Code relating to the stand alone dom-int-toggle-component
function openToggleComponentModal() {
	
	clicked_dom_int_toggle.addClass('toggle_open');
	clicked_dom_int_toggle.find('.dom_int_modal_overlay , .dom_int_modal').fadeIn(function() {
    	//Focus the currently selected item
		clicked_dom_int_toggle.find('.option_container:not(.selected) .option_button').focus();	    	
    });
	
    //Bind the escape key when the modal is opened so it can close the modal
    //NOTE: REMEMBER TO UNBIND THIS "closeModalSwitchContent()" DOES THIS
    //NOTE: If this does not work in all browsers, extend it here
    $(document).on('keydown.dom_int_modal_escape',function(e){
        if(e.which==27)
        {
        	closeDomIntModalSwitchContent('close');
            
        }
    });
    //Bind the document click event and use it's target to decide what to do
    $(document).on('click.d_i_modal', function(e) {
        var click_target = $(e.target);
        var option_container_clicked = click_target.closest('.option_container');
        
        
        if (!click_target.closest('.dom_int_modal').length) {
        	closeDomIntModalSwitchContent('close');
        	
        } 
        else if (option_container_clicked.hasClass('domestic_option')){
        	if(!option_container_clicked.hasClass('selected')) {
        		closeDomIntModalSwitchContent('dom');
        	} else {
        		closeDomIntModalSwitchContent('close');
        	}
        	
        } 
        else if (option_container_clicked.hasClass('international_option')){
        	if(!option_container_clicked.hasClass('selected')) {
        		closeDomIntModalSwitchContent('int');
        	} else {
        		closeDomIntModalSwitchContent('close');
        	}
        	
        } else {
        	closeDomIntModalSwitchContent('close');
        }
    });
    //Because buttons are hard...
    $('.option_button').on("click.d_i_modal_button", function () { 
		var option_container_clicked = $(this).closest('.option_container');

		if (option_container_clicked.hasClass('domestic_option')){
        	if(!option_container_clicked.hasClass('selected')) {
        		closeDomIntModalSwitchContent('dom');
        	} else {
        		closeDomIntModalSwitchContent('close');
        	}
        } 
		else if (option_container_clicked.hasClass('international_option')){
        	if(!option_container_clicked.hasClass('selected')) {
        		closeDomIntModalSwitchContent('int');
        	} else {
        		closeDomIntModalSwitchContent('close');
        	}
        } 
		else {
        	closeDomIntModalSwitchContent('close');
        }
		return false;
	});

}

function closeDomIntModalSwitchContent(action) {
	var the_modal_to_close = $('.dom_int_modal_overlay , .dom_int_modal');
	
	dom_int_toggle_component_container.removeClass('toggle_open');
    if(action === 'dom') {  
		updateDomIntContentUI('dom');
		updateOrSetDomIntCookie('dom');
		the_modal_to_close.delay(before_fade_delay).fadeOut();
    } 
    else if (action === 'int') {    
		updateDomIntContentUI('int');
		updateOrSetDomIntCookie('int');
		the_modal_to_close.delay(before_fade_delay).fadeOut();
        
    } 
    else if (action === 'close') {            	
    	the_modal_to_close.fadeOut();
    } 
    else {
    	the_modal_to_close.fadeOut();
    }
    
    //Unbind events
    $(document).off('click.d_i_modal');
    $(document).off('click.d_i_modal_button');
    $(document).off('keydown.dom_int_modal_escape');
	return false;
}

//Takes care of updating the UI of the stand-alone drag-and-drop domestic/international toggle component
//Accepts an action of 'dom' or 'int' denoting the direction of the change.
function updateToggleComponentUI(action) {
	var toggle_int_option_container = dom_int_toggle_component_container.find('.international_option');
	var toggle_dom_option_container = dom_int_toggle_component_container.find('.domestic_option');
	var toggle_labels_to_update = dom_int_toggle_component_container.find('.toggle_label');
	
    if(action === 'dom') {  
		toggle_labels_to_update.addClass('domestic_colour').removeClass('international_colour');
		dom_int_toggle_component_container.find('.toggle_link_international').hide();
		dom_int_toggle_component_container.find('.toggle_link_domestic').show();
		toggle_dom_option_container.addClass('selected');
		toggle_int_option_container.removeClass('selected');

    } 
    else if (action === 'int') {    
		toggle_labels_to_update.removeClass('domestic_colour').addClass('international_colour');
		dom_int_toggle_component_container.find('.toggle_link_domestic').hide();
		dom_int_toggle_component_container.find('.toggle_link_international').show();
		toggle_dom_option_container.removeClass('selected');
		toggle_int_option_container.addClass('selected');
        
    } 
    else {
    	the_modal_to_close.fadeOut();
    }

	return false;
}

function toggleLocationMode(){
	const newLocationType = current_state === 'dom' ? 'int' : 'dom';
	updateDomIntContentUI(newLocationType);
	updateOrSetDomIntCookie(newLocationType);
	updateSubMenusOrRedirect(newLocationType);
}
